export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CREATE_DRAFT = 'CREATE_DRAFT';
export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATING_ORDER = 'CREATING_ORDER';
export const CREATING_SCHEDULE = 'CREATING_SCHEDULE';
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const FINISH_ORDER = 'FINISH_ORDER';
export const GET_DRAFT = 'GET_DRAFT';
export const GET_ORDER = 'GET_ORDER';
export const GET_ORDER_MENU = 'GET_ORDER_MENU';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_DONE = 'GET_ORDERS_DONE';
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const GET_SCHEDULES = 'GET_SCHEDULES';
export const GET_SCHEDULES_DONE = 'GET_SCHEDULES_DONE';
export const GETTING_ORDERS = 'GETTING_ORDERS';
export const GETTING_SCHEDULES = 'GETTING_SCHEDULES';
export const IS_GETTING_DRAFT = 'IS_GETTING_DRAFT';
export const SET_DEPARTMENT_LIST = 'SET_DEPARTMENT_LIST';
export const SET_DRAFT_ORDER = 'SET_DRAFT_ORDER';
export const SET_SCHEDULE = 'SET_SCHEDULE';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';
export const UPDATE_DRAFT_ORDER = 'UPDATE_DRAFT_ORDER';
export const UPDATE_ENTREE_LIMITS = 'UPDATE_ENTREE_LIMITS';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_ORDER_FAIL = 'UPDATE_ORDER_FAIL';
export const UPDATE_ORDER_TIME = 'UPDATE_ORDER_TIME';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const UPDATE_SCHEDULE_VER2 = 'UPDATE_SCHEDULE_VER2';
